
window.formRecaptcha = function (action, callback) {
	grecaptcha.ready(function() {
		grecaptcha.execute(App.recaptcha.sitekey, {action: action}).then(function(token) {
			callback(token);
		});
	});
};

window.enableRecaptchaForForm = function (form) {
	$(form).submit(function (e) {
		let $input = $(this).find('[name=g-recaptcha-response]');
		let action = $input.data('action');
		let form = this;

		let grecaptchaEmpty = $input.length && !$input.val();

		if (grecaptchaEmpty) {
			let submitter = e.originalEvent.submitter;
			if ($(submitter).is('[type=submit]')) {
				$(submitter).attr('disabled', 'disabled');
			}

			formRecaptcha(action, (token) => {
				$input.val(token);
				form.requestSubmit();
			});

			e.stopImmediatePropagation();
		}

		return false;
	});
}

$(document).on('submit', 'form[data-recaptcha]', function(e) {
	let form = this;
	let $input = $(this).find('[name=g-recaptcha-response]')
	let action = $input.data('action');

	if (!$input.val()) {
		formRecaptcha(action, (token) => {
			$input.val(token);
			form.requestSubmit();
		});

		e.stopImmediatePropagation();

		return false;
	}
});
